import * as React from "react"
import { Fragment } from "react"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    //SearchInput,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    CloneButton,
    ExportButton,
    TextField,
    ReferenceField,
    ReferenceInput,
    TextInput,
    DateField,
    EditButton,
    WrapperField,
    ShowButton,
    BulkExportButton,
    usePermissions,
} from "react-admin"
import * as buttons from "components/ui/buttons"


const getEquipmentFilters = (permissions: string): React.ReactElement[] => {
    const filters = [
        <TextInput source="name" />,
        <ReferenceInput source="equipment_kind_id" reference="equipment-kinds" />,
        <ReferenceInput source="manufacturer_company_id" reference="companies" />,
        <ReferenceInput source="energy_kind_id" reference="energy-kinds" />,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <CreateButton />
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)
const PostBulkActionButtons = () => (
    <Fragment>
        <BulkExportButton />
        <BulkDeleteWithConfirmButton mutationMode="optimistic"/>
    </Fragment>
)


const EquipmentList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()

    return (
        <List
            filters={getEquipmentFilters(permissions)}
            //filterDefaultValues={{ role: "Equipment" }}
            sort={{ field: "created_at", order: "DESC" }}
            actions={<ListActions />}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} bulkActionButtons={<PostBulkActionButtons/>}>
                <ReferenceField label={translate("resources.equipments.fields.name")} source="id" reference="equipments">
                    <TextField source="name" label={translate("resources.equipments.fields.name")} />
                </ReferenceField>
                <ReferenceField label={translate("resources.equipments.fields.equipment_kind_id")} source="equipment_kind_id" reference="equipment-kinds">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label={translate("resources.equipments.fields.manufacturer_company_id")} source="manufacturer_company_id" reference="companies">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label={translate("resources.equipments.fields.energy_kind_id")} source="energy_kind_id" reference="energy-kinds">
                    <TextField source="name" />
                </ReferenceField>
                <DateField showTime source="created_at" label={translate("resources.common.fields.created_at")}></DateField>
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                    <EditButton label="" title={translate("ra.action.edit")}/>
                    <CloneButton label="" title={translate("ra.action.clone")}/>
                    <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="name" />
                </WrapperField>
            </DatagridConfigurable>
        </List>
    )
}

export default EquipmentList